const options = [
  {
    value: 1,
    label: "时间"
  },
  {
    value: 2,
    label: "门店"
  },
  {
    value: 3,
    label: "顾客"
  },
  {
    value: 4,
    label: "会员"
  },
  {
    value: 5,
    label: "客流渠道"
  },
  {
    value: 6,
    label: "预约渠道"
  },
  {
    value: 7,
    label: "项目"
  },
  {
    value: 8,
    label: "储值卡"
  },
  {
    value: 9,
    label: "理疗师"
  },
  {
    value: 10,
    label: "活动"
  },
  {
    value: 11,
    label: "优惠券"
  },
  {
    value: 12,
    label: "券"
  },
  {
    value: 13,
    label: "活动"
  }
];
const queryHeader = [
  // 会员指标概况
  {
    name: "target_manage",
    contrast: false,
    quckTime: "",
    datePicker: "",
    time: "Month",
    headerShow: [
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    // 时间，门店，顾客，会员
    options: options
  },
  //月度目标管理 
  {
    name: "monthly_target_manage",
    contrast: false,
    quckTime: "",
    datePicker: "",
    time: "Month",
    headerShow: [
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    // 时间，门店，顾客，会员
    options: options
  },
  //季度目标管理 
  {
    name: "quarterly_target_manage",
    contrast: false,
    quckTime: "",
    datePicker: "",
    time: "Month",
    headerShow: [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
    ],
    // 时间，门店，顾客，会员
    options: options
  },
  //年度目标管理 
  {
    name: "yearly_target_manage",
    contrast: false,
    quckTime: "",
    datePicker: "",
    time: "Month",
    headerShow: [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
    ],
    // 时间，门店，顾客，会员
    options: options
  },
  // 未续充会员
  {
    name: "nofill_Members",
    contrast: false,
    quckTime: "MonthTabThree",
    datePicker: "DatePicker",
    headerShow: [
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    // 时间，门店，顾客，会员
    options: options
  }
];
const queryContent = [
  // 目标管理
  {
    name: "target_manage",
    value: [
      {
        name: "target_manage",
        selectChart: "",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        oneChart: "",
        chartKey: "",
        tableKey: "store_target_table",
        tableAddress: "bottom",
        tableNum: "6",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: false,
        isTable: true,
        tableTitle: "门店",
        chartZoom: false,
        isTableKey: true,
        constantKey: "",
        headerType: 2,
        parentID: -1,
        TableconstantType: 8,
        ChartconstantType: 8,
        type: 0,
        dateFormat: 1,
        isIndex: false,
        sortIndex: 1
      }
    ]
  },// 月度目标管理
  {
    name: "monthly_target_manage",
    value: [
      {
        name: "monthly_target_manage",
        selectChart: "",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        oneChart: "",
        chartKey: "",
        tableKey: "monthly_target_manage",
        tableAddress: "bottom",
        tableNum: "6",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: false,
        isTable: true,
        tableTitle: "门店",
        chartZoom: false,
        isTableKey: true,
        constantKey: "",
        headerType: 2,
        parentID: -1,
        TableconstantType: 8,
        ChartconstantType: 8,
        type: 0,
        dateFormat: 1,
        isIndex: false,
        sortIndex: 1
      }
    ]
  },// 季度目标管理
  {
    name: "quarterly_target_manage",
    value: [
      {
        name: "quarterly_target_manage",
        selectChart: "",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        oneChart: "",
        chartKey: "",
        tableKey: "quarterly_target_manage",
        tableAddress: "bottom",
        tableNum: "6",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: false,
        isTable: true,
        tableTitle: "门店",
        chartZoom: false,
        isTableKey: true,
        constantKey: "",
        headerType: 2,
        parentID: -1,
        TableconstantType: 8,
        ChartconstantType: 8,
        type: 0,
        dateFormat: 1,
        isIndex: false,
        sortIndex: 1
      }
    ]
  },// 年度目标管理
  {
    name: "yearly_target_manage",
    value: [
      {
        name: "yearly_target_manage",
        selectChart: "",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        oneChart: "",
        chartKey: "",
        tableKey: "yearly_target_manage",
        tableAddress: "bottom",
        tableNum: "6",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: false,
        isTable: true,
        tableTitle: "门店",
        chartZoom: false,
        isTableKey: true,
        constantKey: "",
        headerType: 2,
        parentID: -1,
        TableconstantType: 8,
        ChartconstantType: 8,
        type: 0,
        dateFormat: 1,
        isIndex: false,
        sortIndex: 1
      }
    ]
  },
  // 未续充会员
  {
    name: "nofill_Members",
    value: [
      {
        name: "nofill_Members",
        selectChart: "",
        selectTable: "",
        normalTable: "nofillTable",
        oneChart: "",
        chartKey: "",
        tableKey: "",
        constantKey: "",
        tableAddress: "",
        tableNum: "",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: false,
        isTable: true,
        chartZoom: false,
        isTableKey: true,
        headerType: 1,
        parentID: -1,
        isIndex: false,
        sortIndex: 1
      }
    ]
  }
];
export { queryHeader, queryContent };
